import APIClient from './client'
import { camelizeKeys } from 'humps'

const list = ( brandId ) => {
  return APIClient().get(`/v1/brands/${encodeURIComponent(brandId)}/agency_properties`)
    .then( response => camelizeKeys(response.data))
}

const create = ({ brandId, payload }) => {
  return APIClient().post(
    `/v1/brands/${encodeURIComponent(brandId)}/agency_properties`,
    { agency_property: { name: payload.name } }
  ).then( response => camelizeKeys(response.data))
}

// PATCH, not PUT: only `name` is sent and only `name` is accepted.
const update = ({ id, payload }) => {
  return APIClient().patch(
    `/v1/agency_properties/${encodeURIComponent(id)}`,
    { agency_property: { name: payload.name } }
  ).then( response => camelizeKeys(response.data))
}

// `delete` is a reserved word, so the function has another name and is exposed
// under the `delete` key. A 204 has no body, so there is nothing to camelize.
const destroy = ( id ) => {
  return APIClient().delete(`/v1/agency_properties/${encodeURIComponent(id)}`)
    .then( response => response.data)
}

const AgencyPropertiesAPI = {
  list,
  create,
  update,
  delete: destroy
}

export default AgencyPropertiesAPI
